export default "__VITE_ASSET__DqAnJr0G__"